import {
  DeviceRegistryCommandFunctionType,
  DeviceRegistryCommandKey
} from '@tryiris-ai/common.protojs/api/v1/device_settings';
import { focus } from './focus.js';
import type { Push } from './types.js';

/**
 * One push focus.
 *
 * @param deviceId - The ID of the device to be focused.
 * @returns A promise that resolves when the command has been processed.
 */
export const push: Push = async (deviceId) =>
  focus(deviceId, [
    DeviceRegistryCommandKey.FOCUS_ONE_PUSH_TRIGGER,
    DeviceRegistryCommandFunctionType.ACTION
  ]);
